#import "../fragments/full-activity-fragment.graphql"

query SidebarCalendarActivitiesQuery($dateMin: String!, $dateMax: String!) {
    myActivities(dateMin: $dateMin, dateMax: $dateMax) {
        ...FullActivity
    }
}
